"use strict";
/**
 * Created by Anushavan.Hovsepyan on 12/2/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.log = function (message) {
        Logger.isDevelopmentMode && console.log(message);
    };
    Logger.isDevelopmentMode = false;
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=logger.js.map